<gstar-admin-prime-grid
  #grid
  [source]="source()"
  [headers]="headers"
  [drawerSetting]="drawerSetting"
  [query]="queryWritable()"
  [searchSetting]="searchSetting"
  [normalActionMenu]="actionMenu"
  [actionMenuTitle]="actionMenuTitle"
  (queryChange)="queryHandler($event)" />
